var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"autoplay":_vm.isAutoplay},domProps:{"muted":_vm.isMuted}},[_vm._l((_vm.sources),function(source){return _c('source',{attrs:{"src":source.url,"type":source.type}})}),_vm._v(" Your browser does not support videos. ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }